import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { environment } from '@/app/environments/environment';

@Component({
  selector: 'app-map-dialog',
  templateUrl: './map-dialog.component.html',
  imports: [MatDialogModule, MatIcon],
  styleUrls: ['./map-dialog.component.css'],
  standalone: true,
})
export class MapDialogComponent implements OnInit {
  public googleMapsUrl: SafeResourceUrl;
  google_api_key = environment.apiKey;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { longitude: number; latitude: number },
    private sanitizer: DomSanitizer // Inject DomSanitizer
  ) {}

  ngOnInit(): void {
    const { latitude, longitude } = this.data;
    const url = `https://www.google.com/maps/embed/v1/place?key=${this.google_api_key}&q=${latitude},${longitude}&zoom=14`;
    // Sanitize the URL
    this.googleMapsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
